export function getSourceSetupNextAction(source) {
    return source.viewer_setup_state?.next_action ?? null;
}
export function hasViewerSetupState(source) {
    return getSourceSetupNextAction(source) !== null;
}
export function isViewerSetupReady(source) {
    return getSourceSetupNextAction(source) === 'none';
}
//# sourceMappingURL=sourceSetupState.js.map